import ClayAlert from '@clayui/alert';
import ClayButton from '@clayui/button';
import { ClayInput } from '@clayui/form';
import ClayForm from '@clayui/form';
import ClayIcon from '@clayui/icon';
import ClayModal, { useModal } from '@clayui/modal';
import ClayPanel from '@clayui/panel';
import React, { useState } from 'react';

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const ExportMessages = ({ useExportModal}) => {

    const { exportModal, setExportModal } = useExportModal();

    const { observer, onClose } = useModal({
        onClose: () => setExportModal({ ...setExportModal, visible: false })
    });

    const [showAlert, setShowAlert] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(document.getElementById('formUpdateChild'));

    };
    
    return (
        <>
            {
                exportModal.visible && (
                    <ClayModal
                        observer={observer}
                        size="lg"
                        spritemap={spritemap}
                        status="info" >
                        <form id="formUpdateChild" onSubmit={handleSubmit}>
                            <input type="hidden" name="parentCode" defaultValue={exportModal.data.parentCode} />
                            <input type="hidden" name="idChild" defaultValue={exportModal.data.idChild} />
                            <ClayModal.Body style={{maxHeight: "85vh"}}>
                                <ClayPanel
                                    collapsable
                                    displayTitle="Valor de Mensajes"
                                    displayType="secondary"
                                    spritemap={spritemap}
                                    defaultExpanded >
                                    <ClayPanel.Body>
                                        <ClayForm.Group>
                                            <ClayInput.Group>
                                                <ClayInput.GroupItem>
                                                    <label htmlFor="descriptionOTP">JSON
                                                        <span className="reference-mark">
                                                            <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                        </span>
                                                    </label>
                                                    <ClayInput component={'textarea'} type="text" name='descriptionOTP' id='descriptionOTP' defaultValue={exportModal.data.jsonMessages} />
                                                </ClayInput.GroupItem>
                                            </ClayInput.Group>
                                        </ClayForm.Group>
                                    </ClayPanel.Body>
                                </ClayPanel>
                            </ClayModal.Body>
                            <ClayModal.Footer
                                first={
                                    <ClayButton.Group spaced>
                                        <ClayButton onClick={onClose} displayType="secondary">{"Cancelar"}</ClayButton>
                                    </ClayButton.Group>
                                }
                            />
                        </form>
                        <ClayAlert.ToastContainer>
                            {showAlert && (
                                <ClayAlert
                                    displayType="success"
                                    autoClose="500"
                                    key={Math.random() * 100}
                                    spritemap={spritemap}
                                    onClose={() => setShowAlert(false)}
                                >
                                    Modificado de manera correcta.
                                </ClayAlert>
                            )}
                        </ClayAlert.ToastContainer>
                    </ClayModal>
                )
            }
        </>
    )
};